export const STUDENT_INFO = "STUDENT_INFO";
export const STUDENT_INFO_SUCCESS = "STUDENT_INFO_SUCCESS";
export const STUDENT_INFO_FAILED = "STUDENT_INFO_FAILED";